import bigcommercePartsWarehouseDefaults from '../bigcommerce-parts-warehouse/config.js';

const isOnTrailerHitchCategory = window.location.pathname === '/trailer-hitch/';

export default {
  includes: ['bigcommerce-parts-warehouse'],
  ...bigcommercePartsWarehouseDefaults,
  SearchRequestDefaults: {
    ...bigcommercePartsWarehouseDefaults.SearchRequestDefaults,
    sort: isOnTrailerHitchCategory ? 'price' : 'relevance',
  },
  Widgets: [
    ...bigcommercePartsWarehouseDefaults.Widgets.filter((w) => !['HeaderVehicleWidget'].includes(w.name)),
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: {
        insertAfter: '.main-nav-container',
        class: 'cm_vehicle-widget__home_container cm_desktop cm_mobile-hide',
      },
      template: 'fitmentSearch/collapsibleVehicleWidget',
      columnBreakpoint: 800,
    },
    {
      name: 'CategoryPageCategoriesCarousel',
      type: 'FacetTiles',
      location: { insertAfter: 'body.page-type-category .category.main .breadcrumbs' },
      template: 'facetTiles/subtitles',
      view: 'carousel',
      facetField: 'category',
    },
    {
      name: 'SingleVehicleGarageMobile',
      type: 'SingleVehicleGarage',
      location: {
        insertAfter: 'header.header .mobile-menu',
        class: 'cm_single-vehicle-garage cm_mobile cm_desktop-hide',
      },
      template: 'fitmentSearch/singleVehicleGarage',
    },
  ],
};
